module.exports = __webpack_public_path__ + "fonts/Vazir-Bold.3ef1a73.eot";